import React, { useEffect, useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Input, Label, Spinner } from "reactstrap";

const EpoDecisionModal = ({
    isOpen,
    toggle,
    action = "approve",
    epoNumber,
    onConfirm,
}) => {
    const [comment, setComment] = useState("");
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        if (isOpen) {
            setComment("");
            setSaving(false);
        }
    }, [isOpen]);

    // Round 15 — action can be "approve" | "reject" | "cancel".
    const title =
        action === "approve" ? `Approve EPO #${epoNumber}` :
        action === "cancel"  ? `Cancel EPO #${epoNumber}`  :
                               `Reject EPO #${epoNumber}`;
    const btnText =
        action === "approve" ? "Approve" :
        action === "cancel"  ? "Cancel EPO" :
                               "Reject";
    const btnColor =
        action === "approve" ? "success" :
        action === "cancel"  ? "warning" :
                               "danger";

    const handleSubmit = async () => {
        if (!epoNumber || saving) return;

        setSaving(true);
        try {
            await onConfirm({ epoNumber, comment });
            setComment("");
            toggle();
        } catch (e) {
            console.error("Decision failed:", e);
        } finally {
            setSaving(false);
        }
    };


    return (
        <Modal isOpen={isOpen} toggle={saving ? undefined : toggle} centered>
            <ModalHeader toggle={saving ? undefined : toggle}>{title}</ModalHeader>
            <ModalBody>
                <div className="mb-2">
                    <Label className="form-label">Comment</Label>
                    <Input
                        type="textarea"
                        rows="4"
                        value={comment}
                        onChange={(e) => setComment(e.target.value)}
                        placeholder="Optional comment…"
                        disabled={saving}
                    />
                </div>
                <div className="text-muted" style={{ fontSize: 12 }}>
                    This will update workflow routing based on your approval limit rules.
                </div>
            </ModalBody>
            <ModalFooter>
                <Button color="light" onClick={toggle} disabled={saving}>
                    Close
                </Button>
                <Button color={btnColor} onClick={handleSubmit} disabled={saving}>
                    {saving ? (
                        <>
                            <Spinner size="sm" className="me-2" />
                            Saving…
                        </>
                    ) : (
                        btnText
                    )}
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default EpoDecisionModal;
